<template>
  <div class="flex flex-col pre-diag-record" :class="{ 'large-mode': pageData.largeFontMode }">
    <!--  舌诊记录 start  -->
    <div v-show="pageData.activeDiagRecord.preTreatmentRecord['topTongueImg']!==null" class="flex flex-col mb-10">
      <model-header label="舌诊记录" />
      <!--   舌诊图片 start   -->
      <div class="flex flex-row justify-around mb-10">
        <img
          alt="舌顶"
          :src="pageData.activeDiagRecord.preTreatmentRecord['topTongueImg'] | IMG_URL"
          class="tongue-img"
        >
        <!--        <img-->
        <!--          alt="舌底"-->
        <!--          :src="pageData.activeDiagRecord.preTreatmentRecord['topTongueImg'] | IMG_URL"-->
        <!--          class="tongue-img"-->
        <!--        >-->
      </div>
      <!--   舌诊图片 end   -->
      <!--   舌诊信息 start   -->
      <diag-describe :describe="tongueDesc" />
      <!--   舌诊信息 end   -->
    </div>
    <!--  舌诊记录 end  -->
    <!--  面诊记录 start  -->
    <div v-show="pageData.activeDiagRecord.preTreatmentRecord['faceImg']!==null" class="flex flex-col mb-10">
      <model-header label="面诊记录" />
      <!--   面诊图片 start   -->
      <div class="flex flex-row justify-center mb-10">
        <img alt="面诊" :src="pageData.activeDiagRecord.preTreatmentRecord['faceImg'] | IMG_URL" class="face-img">
      </div>
      <!--   面诊图片 end   -->
      <!--   面诊信息 start   -->
      <diag-describe :describe="faceDesc" />
      <!--   面诊信息 end   -->
    </div>
    <div class="flex flex-col">
      <model-header label="指标" />
      <diag-describe :describe="bloodDesc" />
      <div />
    </div>
  </div>
</template>
<script>
import ModelHeader from "@/components/utils/ModelHeader.vue"
import { getSrc, createClient } from "@/utils/ik/oss/oss"
import DiagDescribe from "@/components/utils/DiagDescribe.vue"
import dicFilterMixin from "@/components/utils/dicFilterMixin"

export default {
  name: "PreDiagRecord",
  components: { DiagDescribe, ModelHeader },
  filters: {
    IMG_URL(url) {
      const client = createClient()
      return getSrc(client, url)
    }
  },
  mixins: [dicFilterMixin],
  inject: ["pageData"],
  computed: {
    tongueDesc() {
      return [
        {
          id: 1,
          label: "舌裂纹",
          value: this.$options.filters.TONGUE_CRACK_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCrackSign)
        },
        {
          id: 2,
          label: "舌胖瘦",
          value: this.$options.filters.TONGUE_FAT_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueFatSign)
        },
        {
          id: 3,
          label: "舌苔厚度",
          value: this.$options.filters.TONGUE_COAT_THICK_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCoatThickSign)
        },
        {
          id: 4,
          label: "舌苔颜色",
          value: this.$options.filters.TONGUE_COAT_COLOR_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCoatThickSign)
        },
        {
          id: 5,
          label: "舌质颜色",
          value: this.$options.filters.TONGUE_COLOR_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCoatThickSign)
        }
      ]
    },
    faceDesc() {
      return [
        {
          id: 1,
          label: "面部颜色",
          value: this.$options.filters.FACE_COLOR_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCrackSign)
        },
        {
          id: 2,
          label: "面部色泽",
          value: this.$options.filters.FACE_LUSTRE_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCrackSign)
        },
        {
          id: 3,
          label: "嘴唇",
          value: this.$options.filters.LIP_COLOR_SIGN(this.pageData.activeDiagRecord.preTreatmentRecord.tongueCrackSign)
        }
      ]
    },
    bloodDesc() {
      return [
        {
          id: 1,
          label: "血压",
          value: `${this.pageData.activeDiagRecord.preTreatmentRecord.systolicPressure}/${this.pageData.activeDiagRecord.preTreatmentRecord.diastolicPressure}`
        },
        {
          id: 2,
          label: "血糖",
          value: this.pageData.activeDiagRecord.preTreatmentRecord.bloodSugar
        }
        // {
        //   id: 3,
        //   label: "血氧",
        //   value: 123
        // },
        // {
        //   id: 4,
        //   label: "体温",
        //   value: 37.5
        // }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .pre-diag-record {
  &.large-mode {
    font-size: 18px;
    .model-header {
      font-size: 20px;
      margin-bottom: 15px;
    }
    .tongue-img, .face-img {
      width: 150px;
      height: 150px;
      margin: 10px;
    }
    .diag-describe {
      font-size: 18px;
      .describe-item {
        margin: 12px 0;
        .label {
          font-size: 18px;
          margin-right: 15px;
          min-width: 120px;
        }
        .value {
          font-size: 18px;
        }
      }
    }
  }
}
.tongue-img {
  width: 107px;
  height: 107px;
  border-radius: 4px;
}

.face-img {
  width: 106px;
  height: 106px;
  border-radius: 4px;
}
</style>
